// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function() {

  // Initialize Swiper for the team-contact__members slider
  const teamContactSwiper = new Swiper('.team-contact__members', {
    slidesPerView: 1,         // Default number of slides per view
    loop: true,              // Do not loop slides (infinite: false)
    pagination: {
      el: '.team-contact__members .swiper-pagination', // Use a dedicated pagination container in the slider HTML
      clickable: true,
    },
    breakpoints: {
      // When window width is >= 600px
      600: {
        slidesPerView: 2
      },
      // When window width is >= 810px
      810: {
        slidesPerView: 3
      },
      // When window width is >= 991px
      991: {
        slidesPerView: 2
        // Dots (pagination) can be hidden via CSS at this breakpoint if needed
      },
      // When window width is >= 1100px
      1100: {
        slidesPerView: 3
      }
    }
  });

  // Initialize Swiper for the team-slider slider
  new Swiper('.team-slider', {
    slidesPerView: 1,
    loop: false,
    pagination: {
      el: '.team-slider .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      600: {
        slidesPerView: 2
      },
      810: {
        slidesPerView: 3
      },
      991: {
        slidesPerView: 2,
      },
      1100: {
        slidesPerView: 3,
      }
    }
  });

  // External navigation for team-contact__members slider
  const prevButton = document.querySelector('.team-contact__slide-prev');
  const nextButton = document.querySelector('.team-contact__slide-next');

  if(prevButton) {
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      teamContactSwiper.slidePrev();
    });
  }
  if(nextButton) {
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      teamContactSwiper.slideNext();
    });
  }

});